import { useEffect } from 'react';
import { sendUiPresence, HEARTBEAT_INTERVAL_MS } from '../util/piPresenceHeartbeat';

/**
 * Heartbeat Pi UI presence while on a session page (calibration or record).
 * Sends { page: "other" } once on unmount; no beforeunload handler.
 *
 * Flag check lives inside useEffect so webpack DefinePlugin can inline
 * process.env.PI_UI_PRESENCE_ENABLED without relying on a browser `process` global.
 */
export function usePiPresence(page) {
  useEffect(() => {
    if (process.env.PI_UI_PRESENCE_ENABLED !== 'true' || !page) {
      return undefined;
    }

    sendUiPresence(page);
    const intervalId = setInterval(() => sendUiPresence(page), HEARTBEAT_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
      sendUiPresence('other');
    };
  }, [page]);
}
